/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';

import {
  getServicesDataDashboardAction,
  getCustomerAssignedContractsAction,
  clearServicesDataDashboardAction,
  getCustomerContractsAssignedUserAction,
} from '../../../actions/license.action';

//import Loading from '../../../components/crosscutting/Loading';
import SearchAutocomplete from '../../../components/form/Autocomplete/SearchAutocomplete';

import WithoutServices from '../../../assets/img/dashboard/withoutServices.svg';
import TableServices from './TableServices';
import appPermissions from '../../../helpers/appPermissions';
import jwtdecode from 'jwt-decode';

const useStyles = makeStyles((theme) => ({
  paper: {
    background: 'linear-gradient(#FFFFFFCC, #ffffff)',
    borderRadius: '30px',
    opacity: 1,
    padding: '5px',
    marginTop: '20px',
  },
  title: {
    ...theme.backOffice.configurations.title,
    fontWeight: 700,
    fontSize: '31px',
    paddingTop: '45px',
    paddingLeft: '20px',
  },
  paperGroup: {
    backgroundColor: '#fff',
    margin: 20,
    borderRadius: 10,
    border: '1px solid #32ACDE',
    padding: 20,
    minHeight: 300,
  },
  searchContainer: {
    marginTop: 15,
    marginBottom: 5,
    width: '50%'
  },
}));

const Dashboard = (props) => {

  const {
    getActionServicesDataDashboard,
    getActionCustomerAssignedContracts,
    getActionCustomerContractsAssignedUser,
    actionClearServicesDataDashboard,
    getServicesDataDashboard,
    customerAssignedContracts,
    history,
  } = props;

  const classes = useStyles();
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerSelected, setCustomerSelected] = useState(null);
  const [customerSearch, setCustomerSearch] = useState('');
  const [loadingCustomer, setLoadingCustomer] = useState(false);
  const [canSearchCustomer, setCanSearchCustomer] = useState(false);

  //=========================================
  // Cargar Dashboard
  //=========================================

  useEffect(() => {
    let token = sessionStorage.getItem('appsUserToken');
    token = token.replace('Bearer ', '');
    const user = jwtdecode(token);
    const userPrivileges = user?.LICENSE_PRIVILEGE || [];
    const permissionForUser = [];
    Object.entries(appPermissions.ModuleDashboard).forEach(([key, permissions]) => {
      const canAccces = permissions?.privileges?.some(
        (privilegeRequired) => userPrivileges.some((userPriv) => userPriv.includes(privilegeRequired)),
      );
      if (canAccces) {
        permissionForUser.push(key);
      }
    });

    //Valida permisos
    const canSearch = permissionForUser.includes("searchCustomer");
    setCanSearchCustomer(canSearch);    
    if (!canSearch){
      getActionCustomerContractsAssignedUser();
    }
  }, []);

  useEffect(() => {
    // if (!canSearchCustomer)
    // return;
    setCustomerOptions(customerAssignedContracts);
    setLoadingCustomer(false);
  }, [customerAssignedContracts, canSearchCustomer]);

  useEffect(() => {    
    setLoadingCustomer(false);
  }, [getServicesDataDashboard]);

  useEffect(() => {
    // if (!canSearchCustomer) {
    //     getActionCustomerAssignedContracts("");
    // }
  }, [canSearchCustomer]);

  //=========================================
  // Buscar clientes
  //=========================================
  const searchCustomers = (filter) => {
    if (!canSearchCustomer)
      return;
    if (!filter || filter.trim().length < 3) {
      setCustomerOptions([]);
      return;
    }
    setLoadingCustomer(true);
    getActionCustomerAssignedContracts(filter);
  };

  //=========================================
  // Cliente seleccionado
  //=========================================
  const handleCustomerSelected = (customer) => {
    setCustomerSelected(customer);
    if (customer != null){
      setLoadingCustomer(true);
      getActionServicesDataDashboard(customer);
    }
  };

  const handleClearSearch = () => {
    setCustomerSearch("");
    setCustomerSelected(null);
    setCustomerOptions([]);
    setLoadingCustomer(false);
    actionClearServicesDataDashboard();
  };

  return (

    <Container component="main" maxWidth="lg">
      <Paper
        elevation={3}
        className={classes.paper}
      >
        <Typography
          color="primary"
          variant="h4"
          className={classes.title}
        >
          Productos adquiridos
        </Typography>
        <Paper
          elevation={3}
          className={classes.paperGroup}
        >
          <div className={classes.searchContainer}>
            <SearchAutocomplete
              label="Razón social o NIT"
              placeholder="Razón social o NIT"
              options={customerOptions}
              value={customerSelected}
              loading={loadingCustomer}
              inputValue={customerSearch}
              allowSearch={canSearchCustomer}
              onInputChange={setCustomerSearch}
              onSearch={searchCustomers}
              onChange={handleCustomerSelected}
              onClear={handleClearSearch}
              getOptionLabel={(option) =>
                `${option.customerName} - ${option.documentType}. ${option.documentNumber}`
              }
            />
          </div>          
          {
            (getServicesDataDashboard.length === 0 && customerSelected != null && !loadingCustomer)
              ? (
                <>
                  <Typography
                    variant="h4"
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      fontWeight: 700,
                      color: '#E55200',
                      fontSize: '35px',
                      marginTop: '25px',
                    }}
                  >
                    ¡Lo sentimos!
                  </Typography>
                  <Typography
                    variant="h5"
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      fontWeight: 600,
                      color: '#6D6E71',
                      fontSize: '30px',
                      marginTop: '45px',
                    }}
                  >
                    Consulta con tu comercial aún no tienes servicios asociados a tu compañía.
                  </Typography>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      marginTop: '45px',
                      marginBottom: '25px',
                    }}
                  >
                    <img
                      src={WithoutServices}
                      alt="withoutServices"
                    />
                  </div>
                </>
              )
              : (loadingCustomer) ? (
                <>
                </>
              ) : (
                <TableServices
                  getServicesDataDashboard={
                    getServicesDataDashboard
                  }
                  history={history}
                  customer={customerSelected}
                />
              )
          }
        </Paper>
      </Paper>
    </Container>
  );
};

const mapStateToProps = (props) => ({
  loading: props.license.loading,
  getServicesDataDashboard: props.license.getServicesDataDashboard,
  customerAssignedContracts: props.license.customerAssignedContracts,  
});

const mapDispatchToProps = {
  getActionServicesDataDashboard: getServicesDataDashboardAction,
  getActionCustomerAssignedContracts: getCustomerAssignedContractsAction,
  actionClearServicesDataDashboard: clearServicesDataDashboardAction,
  getActionCustomerContractsAssignedUser: getCustomerContractsAssignedUserAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Dashboard);